<template>
  <div>
    <div v-if="isJobsPage">
      <div v-if="getWidth === 'lg'" class="tabs is-centered">
        <ul>
          <li v-for="(category,index) in categories" v-if="index < 8"  :class="[ category.value === ecoSystem ? 'is-active': '']"  :key="category.label">
            <a @click="onChange(category.value)"><img v-if="category.image" :src="getImgUrl(category.image)" class="category-icon" />{{category.label}}</a>
          </li>
        </ul>
      </div>
    </div>
    <div v-else class="is-centered">
      <div v-if="getWidth === 'lg'" class="tabs is-centered w-100">
        <ul>
          <li v-for="(category,index) in categories" v-if="index < 8"  :class="[ category.value === ecoSystem ? 'is-active': '']"  :key="category.label">
            <a @click="onChange(category.value)"><img v-if="category.image" :src="getImgUrl(category.image)" class="category-icon" />{{category.label}}</a>
          </li>
        </ul>
      </div>
      <div v-if="getWidth === 'lg'" class="tabs is-centered w-100">
        <ul>
          <li v-for="(category,index) in categories" v-if="index > 8 && index < 16"  :class="[ category.value === ecoSystem ? 'is-active': '']"  :key="category.label">
            <a @click="onChange(category.value)"><img v-if="category.image" :src="getImgUrl(category.image)" class="category-icon" />{{category.label}}</a>
          </li>
        </ul>
      </div>

      <div v-if="getWidth === 'lg'" class="tabs is-centered w-100">
        <ul>
          <li v-for="(category,index) in categories" v-if="index > 16"  :class="[ category.value === ecoSystem ? 'is-active': '']"  :key="category.label">
            <a @click="onChange(category.value)"><img v-if="category.image" :src="getImgUrl(category.image)" class="category-icon" />{{category.label}}</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import {ecoSystemOptions} from '@/constants/array-constants'

export default {
  props: {
    ecoSystem: {
      type: String
    },
    isJobsPage: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      categories: ecoSystemOptions,
      windowWidth: 0
    }
  },
  computed: {
    getWidth () {
      if (this.windowWidth <= 760) {
        return 'xs'
      }
      return 'lg'
    },
    isStacks () {
      return this.$route.meta.stacks
    }
  },
  watch: {
    $route () {
      if (this.isStacks) {
        this.activeItem = 'stacks'
      }
    }
  },
  mounted () {
    this.windowWidth = window.innerWidth
    window.addEventListener('resize', () => {
      this.windowWidth = window.innerWidth
    })
  },
  methods: {
    getImgUrl (imageName) {
      try {
        const images = require.context('../../../assets/', false, /\.png$/)
        return images('./' + imageName + '.png')
      } catch (e) {
        return ''
      }
    },
    onChange (val) {
      this.$emit('change', val)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/styles/defaults.scss";

.w-100{
  width: 100%;
}

.category-icon {
  width: 24px;
  height: 24px;
  margin-right: 12px;
  border-radius: 50%;
}
.tabs {
  border-width: 0px;
  ul {
    li {
      height: auto;
      &:hover {
        background: #f9f9f9;
        border-radius: 4px;
      }

      &.is-active {
        background: $brand-ghost;
        border-bottom-width: 0px;
        border-radius: 4px;
        font-weight: normal;

        a {
          color: $primary;
        }
      }
      a {
        font-size: 14px;
        padding: 8px;
        text-decoration: none;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/jobs/search/categories.vue